import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useUserStore } from '@/entities/user'
import { routes } from '@/shared/config'
import { buildRegistrationStepPath, REGISTRATION_PROFILE_STEP } from '../lib/auth-flow-routing'

export function ProtectedRoute() {
  const { user, isAuthenticated, isLoading } = useUserStore()
  const location = useLocation()

  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.registration} state={{ from: location }} replace />
  }

  if (
    user?.acceptedUserAgreement === false ||
    user?.profileComplete === false ||
    (user?.missingProfileFields?.length ?? 0) > 0
  ) {
    return (
      <Navigate
        to={buildRegistrationStepPath(REGISTRATION_PROFILE_STEP)}
        state={{ from: location }}
        replace
      />
    )
  }

  return <Outlet />
}
